module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/ticket-alt.svg?ed9b816424509841197a3e96ef512f13";